import Axios from "@/plugins/Axios";
import Aluno from "@/Models/Aluno";
import Matricula from "@/Models/Matricula";

class AlunosService {
  async syncAll() {
    const response = await Axios().get("alunos");
    const data = response.data.map((aluno) => new Aluno(aluno));
    return data;
  }

  async syncAllPaginate(pageNumber, query) {
    const response = await Axios().get(`alunos/listAllPaginate?page=${pageNumber}&query=${query}`);
    return response.data;
  }

  async AuditoriaPaginate(pageNumber, query) {
    const response = await Axios().get(
      `alunos/auditoriaPaginate?page=${pageNumber}&query=${query}`
    );
    return response.data.alunos;
  }

  async pegarAluno(id) {
    const response = await Axios().get(`alunos/${id}`);
    const data = new Aluno(response.data);
    return data;
  }

  async criarAluno(aluno) {
    const response = await Axios().post("alunos", aluno);
    const novaAluno = new Aluno(response.data);
    return novaAluno;
  }

  async getAlunoComINEP(codigoInep) {
    const response = await Axios().get(`alunos/codigo-inep/${codigoInep}`);
    return response.data ? new Aluno(response.data) : null;
  }

  async atualizarAluno(aluno) {
    const response = await Axios().put(`alunos/${aluno.id}`, aluno);
    const alunoAtualizada = new Aluno(response.data);
    return alunoAtualizada;
  }

  async deletarAluno(aluno) {
    const response = await Axios().delete(`alunos/${aluno.id}`);
    const alunoDeletada = new Aluno(response.data);
    return alunoDeletada;
  }

  async recuperarAluno(aluno) {
    return this.atualizarAluno({ ...aluno, deleted_at: null });
  }

  async pesquisaAvancada(form) {
    const response = await Axios().post("alunos/pesquisa-avancada", form);
    const alunos = response.data.map((aluno) => new Aluno(aluno));
    return alunos;
  }

  async matriculasAluno(form) {
    const response = await Axios().post("alunos/matriculas-aluno", form);
    const matriculas = response.data.map((matricula) => new Matricula(matricula));
    return matriculas;
  }

  async faixaEtaria(franquiaId = null) {
    const response = await Axios().get(`alunos/faixa-etaria`, {
      params: { franquia_id: franquiaId },
    });
    return response;
  }

  async zona(franquiaId = null) {
    const response = await Axios().get(`alunos/zona`, { params: { franquia_id: franquiaId } });
    return response;
  }

  async generos(franquiaId = null) {
    const response = await Axios().get(`alunos/generos`, { params: { franquia_id: franquiaId } });
    return response;
  }

  async deficientes(franquiaId = null) {
    const response = await Axios().get(`alunos/deficientes`, {
      params: { franquia_id: franquiaId },
    });
    return response;
  }

  async uploadLaudo(laudoData, alunoId) {
    Axios().interceptors.request.use((config) => {
      config.headers["Content-Type"] = "multipart/form-data";
      return config;
    });
    const response = await Axios().post(`alunos/upload-laudo/${alunoId}`, laudoData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response;
  }

  async downloadLaudo(alunoId) {
    const response = await Axios()
      .get(`alunos/download-laudo/${alunoId}`, {
        responseType: "blob",
      })
      .then((response) => {
        const a = document.createElement("a");
        a.href = window.URL.createObjectURL(response.data);
        window.open(a.href);
      });

    return response;
  }

  async uploadImageAluno(file) {
    const formData = new FormData();
    formData.append("file", file);

    const response = await Axios().post("alunos/upload-imagem-do-aluno", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  }

  async cortarImageAluno(tamanhos, name) {
    const response = await Axios().post("cortar-imagem-aluno", {
      coordinates: tamanhos,
      nameFile: name,
    });

    return response.data;
  }

  async carregarImagemPrivada(filename) {
    try {
      const response = await Axios().get(`imagem-do-aluno/privada/${filename}`, {
        responseType: "blob",
      });
      return URL.createObjectURL(response.data);
    } catch (error) {
      return "/placeholde-aluno.jpeg";
    }
  }
}

export default new AlunosService();
